export default __webpack_public_path__ + "02468f7a7e816867c9c37d7a5b2fe886.svg";